import { Mutation } from '@apollo/client/react/components';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import CancelScheduleIcon from '@mui/icons-material/CancelScheduleSend';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SAVE_DRAFT } from '../../../helpers/graphql/drafts';
import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

class UnScheduleButton extends Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  newNotification(notification) {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      const { enqueueSnackbar } = this.props;
      enqueueSnackbar(notification.message, { variant });
    }
  }

  render() {
    const { id, onDelete } = this.props;
    const { open } = this.state;
    return (
      <Mutation
        mutation={SAVE_DRAFT}
        variables={{
          draft: {
            id,
            scheduledDate: null,
          },
        }}
      >
        {(addDraft, data) => {
          if (data.data && data.data.addDraft && open) {
            this.handleClose();
            if (!data.data.addDraft.success) {
              this.newNotification({
                success: data.data.addDraft.success,
                message: data.data.addDraft.message,
              });
            }
            if (data.data.addDraft.success) {
              onDelete();
            }
          }
          return (
            <>
              <span className="text-light">
                <Button
                  onClick={this.handleClickOpen}
                  className="p-0 pr-2 pl-2"
                >
                  <span className="textPrimary pr-1">Unschedule</span>
                  <CancelScheduleIcon />
                </Button>
              </span>
              <Dialog
                open={open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Revert Scheduled Post to Draft?
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure that you want to cancel the scheduled post?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary" autoFocus>
                    Cancel
                  </Button>
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                      <Button
                        variant="contained"
                        onClick={addDraft}
                        color="primary"
                      >
                        <span className="textPrimary pr-1">Revert</span>
                        <CancelScheduleIcon />
                      </Button>
                    </ThemeProvider>
                  </StyledEngineProvider>
                </DialogActions>
              </Dialog>
            </>
          );
        }}
      </Mutation>
    );
  }
}

UnScheduleButton.propTypes = {
  id: PropTypes.string.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default withSnackbar(UnScheduleButton);
